<script setup lang="ts">
import { ref } from 'vue';
import { useForm, Field as VeeField } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import * as z from 'zod';
import {
	FieldGroup,
	Field,
	FieldLabel,
	FieldError
} from '@/components/ui/field';
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
} from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import Textarea from '@/components/ui/textarea/Textarea.vue';
import { AlertCircleIcon } from '@lucide/vue'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

import Altcha from '@/components/altcha/altcha.vue';

const token = document.getElementById('app')?.dataset?.token;
const formSchema = toTypedSchema(z.object({
  	name: z.string().min(5),
	email: z.string().email(),
	subject: z.string().optional(),
	message: z.string().min(10),
	token: z.string().optional()
}))
const form = useForm({
  validationSchema: formSchema,
})

const altchaPayload = ref('');
const submitted = ref(false);
const errMsg = ref('');

const onSubmit = form.handleSubmit(async (data) => {
	data.token = token;
	console.log('onSubmit:data='+JSON.stringify(data));
	const btn = document.getElementById('send_btn');
	if (btn) {
		try {
			btn.setAttribute('disabled','disabled');
			btn.innerText = 'Sending...';
			const response = await fetch('/api/contact-message',{
				method: 'POST',
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(data),
			});
			const result = await response.json();
			if (result.success) {
				submitted.value = true;
			} else {
				throw new Error(result.message);
			}

			

		} catch (err) {
			console.error(err);
			btn.removeAttribute('disabled');
			btn.innerText = 'Send';
			if (err instanceof Error) { errMsg.value = err.message };
		}
	}
});

</script>
<template>
	<Card class="w-150 max-w-full mx-auto contactcard">
		<CardHeader>
			<CardTitle></CardTitle>
			<CardDescription></CardDescription>
			<Alert v-if="errMsg" variant="destructive">				
				<AlertTitle class="flex gap-2"><AlertCircleIcon/>{{ errMsg }}</AlertTitle>
				<AlertDescription></AlertDescription>
			</Alert>
		</CardHeader>
		<CardContent>
			<div v-if="submitted" class="p-4">
				<h2>Thank You</h2>
				<p class="p-2">🙏 Thank you for contacting Evolke. We'll get back to you as soon as possible</p>
			</div>
			<form @submit="onSubmit" v-else>
			<FieldGroup>
				<VeeField v-slot="{ field, errors }" name="name">
					<Field :data-invalid="!!errors.length">
						<FieldLabel for="name">Name*</FieldLabel>
						<Input id="name" v-bind="field" required />
						<FieldError v-if="errors.length" :errors="errors" />
					</Field>
				</VeeField>
				<VeeField v-slot="{ field, errors }" name="email">
					<Field :data-invalid="!!errors.length">
						<FieldLabel for="email">Email Address*</FieldLabel>
						<Input id="email" type="email" v-bind="field" required />
						<FieldError v-if="errors.length" :errors="errors" />
					</Field>
				</VeeField>
				<VeeField v-slot="{ field, errors }" name="subject">
					<Field :data-invalid="!!errors.length">
						<FieldLabel for="subject">Subject</FieldLabel>
						<Input id="subject" v-bind="field" />
						<FieldError v-if="errors.length" :errors="errors" />
					</Field>
				</VeeField>
				<VeeField v-slot="{ field, errors }" name="message">
					<Field :data-invalid="!!errors.length">
						<FieldLabel for="message">Message*</FieldLabel>
						<Textarea id="message" v-bind="field" required></Textarea>
						<FieldError v-if="errors.length" :errors="errors" />
					</Field>
				</VeeField>
				<Field>
					<Altcha v-model:payload="altchaPayload" />
				</Field>
				<Field>
					<Button type="submit" id="send_btn">Send</Button>
				</Field>
				<Field>
					<input type="hidden" id="token" name="token" :value="token" />
				</Field>
			</FieldGroup>
		 </form>	
		</CardContent>
		<CardFooter></CardFooter>
	</Card>
</template>